import { Controller } from '@hotwired/stimulus';

/**
 * Moves focus to the feedback card heading when unlock reveals the section
 * (style.display: none → visible). Ignores unrelated class/style toggles such as
 * AI-pair hide/show so those do not steal focus.
 */
export default class extends Controller {
  connect() {
    this._wasDisplayNone = this.isDisplayNone();
    this._observer = new MutationObserver(() => this.syncFocusOnReveal());
    this._observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  disconnect() {
    this._observer?.disconnect();
    this._observer = null;
  }

  isDisplayNone() {
    return this.element.style.display === 'none';
  }

  isHidden() {
    if (this.isDisplayNone()) return true;
    if (this.element.classList.contains('doc-section--hide-for-ai-pair')) return true;
    const style = window.getComputedStyle(this.element);
    return style.display === 'none' || style.visibility === 'hidden';
  }

  syncFocusOnReveal() {
    const displayNone = this.isDisplayNone();
    if (this._wasDisplayNone && !displayNone && !this.isHidden()) {
      this.focusHeading();
    }
    this._wasDisplayNone = displayNone;
  }

  focusHeading() {
    const heading =
      this.element.querySelector('[id^="feedback-card-heading-"]') ||
      this.element.querySelector('.feedback-card-content h2');
    if (!(heading instanceof HTMLElement)) return;

    if (!heading.hasAttribute('tabindex')) {
      heading.tabIndex = -1;
    }
    heading.focus({ preventScroll: false });
  }
}
